/**
 * Interface for determining when to show auth dialogs and which view to display
 */
export class AuthDialogInterface {
  /**
   * Determines if the auth dialog should be shown
   * @param {Object} context - The application context including user, app, location, etc.
   * @returns {boolean} - Whether the dialog should be shown
   */
  shouldShowDialog(context) {
    throw new Error('shouldShowDialog must be implemented');
  }

  /**
   * Determines which view should be displayed in the auth dialog
   * @param {Object} context - The application context including user, app, location, etc.
   * @returns {string} - The view type to show ('login', 'signup', 'verify', 'consent', 'missing-email')
   */
  viewToShow(context) {
    throw new Error('viewToShow must be implemented');
  }

  /**
   * Name of this auth case for debugging
   * @returns {string} - Case name
   */
  getCaseName() {
    throw new Error('getCaseName must be implemented');
  }
}
